<template>
  <label class="checkbox_wrap mb_16" :class="classNameWrapper" for="">
    <div style="line-height:1;">
      <div
        class=""
        :class="disabled ? 'checkbox_disable' : ''"
        @click="onToggle"
        v-html="checkBoxIcon"
      ></div>
    </div>
    <div class="font_regular font_500 text_14 " :class="className">
      {{ label }}
    </div>
  </label>
</template>

<script>
import { svgIcons } from '../../../../shared/components/FluentIcon/svg_icons';

export default {
  props: {
    className: {
      type: String,
      default: '',
    },
    classNameWrapper: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: 'checkbox', // checkbox, radio
    },
  },
  data() {
    return {};
  },
  computed: {
    // similarly add radio
    checkBoxIcon() {
      if (this.iconName === 'radio') {
        return svgIcons.radio({
          isChecked: this.value,
          width: 20,
          height: 20,
        });
      }
      return svgIcons.checkBox({
        isChecked: this.value,
        width: 20,
        height: 20,
      });
    },
  },
  methods: {
    onToggle() {
      if (this.disabled) {
        return;
      }
      this.$emit('onToggle', !this.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.checkbox_wrap {
  display: flex;
  gap: 4px;
}
</style>

<style>
.checkbox_wrap .checkbox_disable svg path {
  fill: #eee;
}
</style>
